<div class="help-container" [ngClass]="{'left': showOnLeft}" *ngIf="visible && labelObj">
  <div>
    <div class="help-title">
      <h3 [innerHTML]="labelObj.title"></h3>
    </div>
    <div class="help-close">
      <button mat-button mat-icon-button aria-label="Close Icon" class="cancelbtn"
        (click)="closeDialog(); $event.stopPropagation();">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="help-subtitle" *ngIf="labelObj.subTitle">
    <h4 [innerHTML]="labelObj.subTitle"></h4>
  </div>

  <div class="row body">
    <p [innerHTML]="labelObj.body"></p>
  </div>
  <div class="help-footer" *ngIf="labelObj?.footer?.text"><a
      [href]="labelObj?.footer?.docLink">{{labelObj?.footer?.text}}</a></div>
</div>